import { render, staticRenderFns } from "./ServicosLista.vue?vue&type=template&id=1ef16b0c&scoped=true&"
import script from "./ServicosLista.vue?vue&type=script&lang=js&"
export * from "./ServicosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef16b0c",
  null
  
)

export default component.exports